import { render, staticRenderFns } from "./Praktisch.vue?vue&type=template&id=ad109af2"
import script from "./Praktisch.vue?vue&type=script&lang=ts"
export * from "./Praktisch.vue?vue&type=script&lang=ts"
import style0 from "./Praktisch.vue?vue&type=style&index=0&id=ad109af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports